<template>
  <div class="position-ab">
    <div class="ccui-app-box-iframe-operate-container">
      <breadcrumbSourcing
        :breadcrumb-data="breadcrumbData"
      ></breadcrumbSourcing>
      <div class="ccui-app-iframe-container-detail">
        <div class="ccui-app-iframe-container-detail-body">
          <div class="ccui-tab-iframe">
            <div class="ccui-tab-wrapper">
              <el-button type="table-top-active" size="mini"
                >专家承诺书确认</el-button
              >
            </div>
          </div>
          <div class="content">
            <p class="title">评标专家承诺书</p>
            <p>作为项目的评标小组成员，谨在此郑重承诺：</p>
            <br />
            <p>
              1、履行相关的保密义务，遵守评标纪律，不私下接触投标人，不收受他人的财物或其他好处，不透漏对投标文件的评审和比较、中标候选人的推荐情况以及与评标有关的其他情况；
            </p>
            <p>
              2、客观、公正地履行职责，遵守职业道德，严格按照招标文件规定的评标标准、办法和有关法律、法规的规定进行评标，对评审（分）结果署名并承担个人责任；
            </p>
            <p>
              3、我小组成员如涉嫌泄密，且泄密情形严重的，我小组所有评标专家自愿暂停一至六个月评标资格；
            </p>
            <p>
              4、对于涉嫌泄密事宜，我小组成员接受、协助、配合监督部门的监督检查，并履行举证义务。
            </p>
            <br />
            <p>特此承诺！</p>
            <br />
            <br />
            <p>备注：</p>
            <p>
              1.涉嫌泄密的情形主要是指评标过程中的细节性信息、内容、环节，比如：评审过程中的争议、对争议问题的投票表决情况、未形成文字的专家现场评论等；
            </p>
            <p>2.泄密内容不包括可在评标结果公示中公开的评标结论性内容。</p>
            <p>
              3.涉嫌泄密情形的判断，相关监管部门将进行严格的分析鉴别。经查实，泄密情形属实的，对泄密专家按有关规定从严处罚。
            </p>
          </div>
          <div class="divder">
            <el-form :model="form" label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :label="
                      `${
                        purchaseType == 1 ||
                        purchaseType == 4 ||
                        purchaseType == 7 ||
                        purchaseType == 8
                          ? '评审'
                          : '评标'
                      }专家：`
                    "
                  >
                    {{ form.expertName }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="
                      `${
                        purchaseType == 1 ||
                        purchaseType == 4 ||
                        purchaseType == 7 ||
                        purchaseType == 8
                          ? '评审'
                          : '评标'
                      }日期：`
                    "
                  >
                    {{ form.commitmentTime }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <template v-if="operateShow">
        <div class="operate">
          <div>
            <el-button
              v-if="form.commitmentFlag != '1'"
              v-preventReClick
              icon="icon-ccui-agree"
              type="text"
              @click="agree"
              :disabled="form.commitmentFlag == '1'"
              >同意</el-button
            >
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryExpertCommitmentApi,
  scpDealExpertCommitmentApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  name: "subLetterCommitmentConfirm",
  components: {
    breadcrumbSourcing
  },
  inject: ["reload"],
  data() {
    return {
      purchaseType: JSON.parse(sessionStorage.getItem("expertSourceData"))
        .purchaseType, // 招标方式
      form: {
        commitmentTime: "",
        expertName: "",
        commitmentFlag: "0" // 0：未承诺 1：已承诺
      },
      breadcrumbData: {
        titname: "承诺书确认"
      },
      operateShow: false
    };
  },
  mounted() {
    let myDate = new Date();
    this.form.commitmentTime = `${myDate.getFullYear()}-${
      myDate.getMonth() + 1 < 10
        ? "0" + (myDate.getMonth() + 1)
        : myDate.getMonth() + 1
    }-${myDate.getDate()} ${
      myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours()
    }:${
      myDate.getMinutes() < 10 ? "0" + myDate.getMinutes() : myDate.getMinutes()
    }:${
      myDate.getSeconds() < 10 ? "0" + myDate.getSeconds() : myDate.getSeconds()
    }`;
    this.qryExpertCommitment();
  },
  methods: {
    qryExpertCommitment() {
      scpQryExpertCommitmentApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId
      }).then(res => {
        this.operateShow = false;
        this.form = res.data.data;
        this.operateShow = true;
      });
    },
    agree() {
      this.$confirm("您确定同意专家承诺书确认吗？", "专家承诺书确认", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "ccui-message-box-custom"
      })
        .then(() => {
          scpDealExpertCommitmentApi({
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            commitmentTime: this.form.commitmentTime
          }).then(res => {
            if (res.data.code == "0") {
              this.$message({
                message: "专家承诺书确认成功！",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
              this.qryExpertCommitment();
              this.reload();
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 3%;
  border: 1px solid #d1d1d1;
  border-radius: 3px;
  .title {
    text-align: center;
    font-size: 18px;
  }
}
/deep/ .el-table td {
  height: 36px !important;
  line-height: 36px !important;
}

.divder {
  margin-top: 20px;
}
</style>
<style>
.ccui-top-bar-wrapper {
  display: none;
}
</style>
